import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quoteFields: {
    accountName: "",
    accountNumber: "",
    contactName: "",
    city: "",
    customerName: "",
    expirationDate: "",
    execName: "",
    execNumber: "",
    phoneNumber: "",
    parentNumber: "",
    parentName: "",
    taxRate: "0.00",
    isTaxChanged: false,
    quoteType: "",
    prcNumber: "",
    prcDesc: "",
    jobNumber: "",
    jobName: "",
    salesRep: "",
    storeName: "",
    storeNumber: "",
    storePhoneNumber: "",
    state: "",
    street: "",
    territory: "",
    quoteName: "",
    quoteId: "",
    zip: "",
  },

  bulkUpdateSearchFields: {
    accountNumber: "",
    accountName: "",
    productCategory: { id: null, label: "", description: "" },
    laborCode: { id: null, label: "", description: "" },
    salesNumber: "",
    storeNumber: "",
    parentNumber: "",
  },
  bulkUpdatePriceData: {
    priceType: { id: "", label: "", description: "" },
    priceAmount: { id: "", label: "", description: "" },
    price: "",
  },
  bulkUpdateType: "",
  showBulkUpdateSearchTable: false,
  bulkEditTableList: [],
  selectedQuotes: [],
  bulkEditConfirmationTableList: [],
  searchFilterBulkEditValue: "",
  isSelectAllCheckedQuote: false,
  quoteList: [],
  floorPlans: [],
  isSelectAllCheckedLabor: false,
  isSelectAllCheckedProducts: false,
  laborCodeLookupData: [],
  prcList: [],
  productCategorylist: [],
  pdfOptions: {},
  bulkPricesQuoteData: {},
};

const priceQuote = createSlice({
  name: "priceQuote",
  initialState,
  reducers: {
    updateBulkEditSearchFields(state, action) {
      const { key, value } = action.payload;
      if (["productCategory", "laborCode"].includes(key) && !value?.id) {
        state.bulkUpdateSearchFields[key] = initialState.bulkUpdateSearchFields[key];
      }
      state.bulkUpdateSearchFields[key] = value;
    },
    updateBulkPriceFields(state, action) {
      const { key, value } = action.payload;
      if (["priceType", "priceAmount"].includes(key) && !value?.id) {
        state.bulkUpdatePriceData[key] = initialState.bulkUpdatePriceData[key];
      }
      state.bulkUpdatePriceData[key] = value;
    },
    clearBulkEditSearchFields(state) {
      state.bulkUpdateSearchFields = initialState.bulkUpdateSearchFields;
      state.showBulkUpdateSearchTable = initialState.showBulkUpdateSearchTable;
    },
    clearPrcList(state) {
      state.prcList = initialState.prcList;
    },
    updateBulkEditSearchFilterValue(state, action) {
      state.searchFilterBulkEditValue = action.payload;
    },
    getBulkQuoteData(state, action) {
      state.bulkPricesQuoteData = action.payload;
    },
    duplicateQuote(state, action) {
      state.quoteFields = { ...state.quoteFields, ...action.payload.quoteData };
      state.floorPlans = action.payload.quoteData.floorList;
    },
    floorNameUpdate(state, action) {
      const { floorId, floorPlanName } = action.payload;
      const floor = state.floorPlans.find((floor) => floor.floorId == floorId);
      if (floorPlanName && !(floorPlanName === null)) {
        floor.floorName = floorPlanName;
      }
    },
    getLaborCodeList(state, action) {
      state.laborCodeLookupData = action.payload;
    },
    getPrcList(state, action) {
      state.prcList = action.payload;
    },
    quoteSelection(state, action) {
      const bulkEditTableListNew = [...state.bulkEditTableList].map((item) => {
        if (item.quoteId === action.payload) {
          return { ...item, isSelected: item.isSelected ? false : true };
        } else return { ...item };
      });

      state.bulkEditTableList = bulkEditTableListNew;
    },
    selectAllQuotes(state, action) {
      let isSelectAllCheckedQuote = state.isSelectAllCheckedQuote;
      let tableData = action.payload;
      const bulkEditTableListNew = JSON.parse(JSON.stringify(state.bulkEditTableList));
      if (isSelectAllCheckedQuote) {
        tableData.map((user) => {
          bulkEditTableListNew[user.elementIndex].isSelected = false;
        });
        isSelectAllCheckedQuote = false;
      } else {
        tableData.map((user) => {
          bulkEditTableListNew[user.elementIndex].isSelected = true;
        });
        isSelectAllCheckedQuote = true;
      }

      state.bulkEditTableList = bulkEditTableListNew;
      state.isSelectAllCheckedQuote = isSelectAllCheckedQuote;
    },
    resetSelectedQuotes(state) {
      state.bulkEditTableList.forEach((item) => (item.isSelected = false));
      state.isSelectAllCheckedQuote = false;
      state.bulkUpdateSearchFields = initialState.bulkUpdateSearchFields;
      state.showBulkUpdateSearchTable = initialState.showBulkUpdateSearchTable;
    },
    bulkUpdatePrices(state, action) {
      state.bulkEditConfirmationTableList = action.payload;
    },
    updateSelectedQuotes(state, action) {
      state.selectedQuotes = action.payload;
    },
  },
});

export const {
  updateBulkEditSearchFields,
  updateBulkPriceFields,
  clearBulkEditSearchFields,
  clearPrcList,
  updateBulkEditSearchFilterValue,
  getBulkQuoteData,
  duplicateQuote,
  floorNameUpdate,
  getLaborCodeList,
  getPrcList,
  quoteSelection,
  selectAllQuotes,
  resetSelectedQuotes,
  bulkUpdatePrices,
  updateSelectedQuotes,
} = priceQuote.actions;
export default priceQuote.reducer;
